import _ from 'lodash';

import { creditCardService, eventService } from '../../services/homii-services';

import localStorageService from '../../services/storage-service/local-storage.service';

import { PAYMENT_STATUS_ENUM, HOMII_KEYS } from '../../../utils/constants';

const SUCCESSFUL_BOOKING_EVENT = HOMII_KEYS.SUCCESSFUL_BOOKING_EVENT;
const HOMII_TRANSACTION_KEY = HOMII_KEYS.TRANSACTION_KEY;
const HOMII_PAYMENT_METHOD = HOMII_KEYS.PAYMENT_METHOD;

const paymentTypes = {
    CREDIT_CARD: 'card',
    INSTANT_EFT: 'instant_EFT',
};

async function getEmbeddedPaymentStatus() {    
    const paymentMethod = localStorageService.getItem(HOMII_PAYMENT_METHOD);    
    if (!paymentMethod) {
        return {
            paymentStatus: PAYMENT_STATUS_ENUM[2],
            message: 'No payment has been actioned.',
        };
    }
    if (paymentMethod === paymentTypes.CREDIT_CARD) {
        return await getEmbeddedPaymentStatusByService(creditCardService.getEmbeddedPaymentStatus)       
    }   
};

async function getEmbeddedPaymentStatusByService(service) {
  
    let transactionId;

    try {
        let storage = localStorageService.getItem(HOMII_TRANSACTION_KEY);
        if (storage) {
            transactionId = storage;
        }

        if (!transactionId) {
            return {
                paymentStatus: PAYMENT_STATUS_ENUM[2],
                message: 'Transaction not found',
            };
        }

        const paymentStatusResponse = await service(transactionId);
        const paymentStatus = PAYMENT_STATUS_ENUM[_.get(paymentStatusResponse, 'outcome')];
        const paymentStatusOutcomeDescription = _.get(
            paymentStatusResponse,
            'outcomeDescription',
            '',
        );

        if (paymentStatus === PAYMENT_STATUS_ENUM[1]) {
            localStorageService.setItem(SUCCESSFUL_BOOKING_EVENT, true);
            eventService.logCustomEvent('successful_payment', {
                description: 'Payment successful',
            });

            return {
                paymentStatus: PAYMENT_STATUS_ENUM[1],
                message: 'Success',
            };
        }

        if (paymentStatus === PAYMENT_STATUS_ENUM[2]) {
            localStorageService.setItem(SUCCESSFUL_BOOKING_EVENT, false);
            eventService.logCustomEvent('payment_failed', {
                description: `Payment Failed with id ${_.get(
                    paymentStatusResponse,
                    'requestId',
                    'unknown',
                )}.  ${paymentStatusOutcomeDescription}`,
            });
            return {
                paymentStatus: PAYMENT_STATUS_ENUM[2],
                message: `Payment failed with error: "${paymentStatusOutcomeDescription}"`,
            };
        }

        return {
            paymentStatus: PAYMENT_STATUS_ENUM[0],
            message: 'Payment is still being processed',
        };
    } catch (error) {        
        eventService.logCustomEvent('payment_failed', {
            description: `Payment Failed with id ${_.get(
                error,
                'response.headers.x-request-id',
                'unknown',
            )}`,
        });
        return {
            paymentStatus: PAYMENT_STATUS_ENUM[2],
            message: `Error occurred while processing the transaction. Request ID: ${_.get(
                error,
                'response.headers.x-request-id',
                'unknown',
            )}`,
        };
    }
    
}

export default {   
    getEmbeddedPaymentStatus
}